import S from "./index.module.scss";
import { FC } from "react";
import { ImpactType } from "@/views/about/constants/impact";
import { ButtonLink } from "@/components/ui/button";
import { useTranslations } from "next-intl";

interface IDnaCard {
  item: ImpactType;
}

const ImpactCard: FC<IDnaCard> = ({ item }) => {
  const t = useTranslations("about");

  return (
    <div className={S.wrapper}>
      <span className={S.title}>{t(`${item.title}`)}</span>
      <span className={S.description}>{t(`${item.description}`)}</span>
      <ButtonLink arrow href={item.link}>
        {t("findOutMore")}
      </ButtonLink>
    </div>
  );
};

export default ImpactCard;
